import { ResolveState } from '../../../common';
import { Updater } from '../../../upgrade/models/updater-interface';
import { ErrorResult } from '../../../upgrade/models/error-result';
import { Logger } from '../../utils/logger';

/**
 * Updater for AjaxResponse errors.
 */
export class AjaxResponseUpdater implements Updater {
    /**
     * The update function.
     * @param fileData the file data.
     * @param error the error object.
     * @returns The updated file data.
     */
    public update(fileData: string, error: ErrorResult): Promise<string> {
        if (!fileData) {
            Logger.error(`Cannot find file data`);
        }

        const result = this.regexFixer(fileData);

        error.resolved = ResolveState.Resolved;
        return new Promise(resolve => resolve(result));
    }

    /**
     * Fix file data by regex matching.
     * @param inputString the input file data string.
     * @returns the updated file data string.
     */
    private regexFixer(inputString): string {
        const regexPattern = /AjaxResponse/;

        if (regexPattern.test(inputString)) {

            const data = inputString.split('\n');

            const goodIndicater = ['<AjaxResponse', ':AjaxResponse', ': AjaxResponse'];

            for (let i = 0; i < data.length; i++) {
                for (let j = 0; j < goodIndicater.length; j++) {
                    if (data[i].includes(goodIndicater[j]) && !data[i].includes('AjaxResponse<any>')) {
                        data[i] = data[i].replace('AjaxResponse', 'AjaxResponse<any>');
                        Logger.log(data[i]);
                    }
                }
            }

            return data.join('\n');
        } else {
            Logger.log('no-op')
        }

        return inputString;
    }
}
